export default {
  // updateAuthorizationUrl (state, payload) {
  //   state.authorizationUrl = payload
  // }
  menuList (state, payload) {
    state.menuList = payload
  },
  detectionPackageList (state, payload) {
    state.detectionPackageList = payload
  },
  goodsTypeList (state, payload) {
    state.goodsTypeList = payload
  },
  updateTenantInfo (state, payload) {
    // 创建一个新的对象，将info,state.personInfo对象复制到新对象中
    let data = Object.assign({}, state.saasConfig)
    data.tenant = payload.id
    data.currentApiServer = payload.gateway
    data.menuLogoUrl = payload.menuLogoUrl
    data.loginLogoUrl = payload.loginLogoUrl
    localStorage.setItem('tenant', payload.id)
    state.saasConfig = data
  },
  updateFocusView (state, payload) {
    let data = Object.assign({}, state.saasConfig)
    data.focusView = payload
    localStorage.setItem('focusView', payload)
    state.saasConfig = data
  },
  updateContractSwitch (state, payload) {
    let data = Object.assign({}, state.saasConfig)
    data.openContract = payload
    state.saasConfig = data
  },
  updateChipType (state, payload) {
    state.chipType = payload
  }
}
